module.exports = __webpack_public_path__ + "static/media/cell_notify_default.9945ac22.jpg";